export interface IndustryData {
  id: string;
  name: string;
  icon: string;
  subIndustries: string[];
  useCases: string[];
}

export const industries: IndustryData[] = [
  {
    id: 'finance',
    name: '金融/投资',
    icon: '🏦',
    subIndustries: [
      '银行',
      '证券',
      '保险',
      '基金',
      '支付',
      '财富管理'
    ],
    useCases: [
      '智能投顾',
      '风险控制',
      'DeFi应用',
      '数字资产管理',
      '智能合规',
      '反洗钱'
    ]
  },
  {
    id: 'tech',
    name: '科技/互联网',
    icon: '💻',
    subIndustries: [
      '电商',
      '社交媒体',
      '云计算',
      '人工智能',
      '区块链',
      '物联网'
    ],
    useCases: [
      '推荐系统',
      '智能客服',
      '内容审核',
      '智能运维',
      'Web3应用开发',
      '数据分析'
    ]
  },
  {
    id: 'manufacturing',
    name: '制造/供应链',
    icon: '🏭',
    subIndustries: [
      '智能制造',
      '汽车',
      '电子',
      '新能源',
      '物流',
      '仓储'
    ],
    useCases: [
      '预测性维护',
      '质量控制',
      '供应链优化',
      '库存管理',
      '生产调度',
      '追溯系统'
    ]
  },
  {
    id: 'education',
    name: '教育/培训',
    icon: '🎓',
    subIndustries: [
      'K12教育',
      '高等教育',
      '职业培训',
      '在线教育',
      '教育科技',
      '语言学习'
    ],
    useCases: [
      '个性化学习',
      '智能题库',
      '学习分析',
      '虚拟课堂',
      '教学助手',
      '能力评估'
    ]
  },
  {
    id: 'healthcare',
    name: '医疗健康',
    icon: '🏥',
    subIndustries: [
      '医院',
      '制药',
      '医疗器械',
      '健康管理',
      '生物科技',
      '远程医疗'
    ],
    useCases: [
      '医学影像',
      '药物研发',
      '疾病预测',
      '健康监测',
      '智能诊断',
      '临床决策支持'
    ]
  },
  {
    id: 'entertainment',
    name: '文娱/创意',
    icon: '🎨',
    subIndustries: [
      '游戏',
      '视频',
      '音乐',
      '直播',
      '数字艺术',
      '虚拟现实'
    ],
    useCases: [
      'AI创作',
      '内容生成',
      '游戏AI',
      '虚拟主播',
      '推荐算法',
      '版权保护'
    ]
  }
];